import MasterPlan from './masterPlan'

export default MasterPlan